import { Text } from '@oneaudi/unified-web-alpha-components';
import { useI18n } from '~/app/i18n/i18n';
import { useFootnotes } from '~/components/footnotes';
import { PRICE_DISCLAIMER_REMARK } from '~/components/footnotes/constants';
import { FootnoteReferenceNgc } from '~/components/footnotes/footnote-reference';
import { PriceFragment } from '~/graphql/__generated__/graphql';
import { useCurrencyFormatter } from '~/hooks/use-currency-formatter';

export default function PriceDetail({
	priceFragment,
	showDisclaimer,
}: {
	priceFragment: PriceFragment | undefined;
	showDisclaimer: boolean;
}) {
	const { formatCurrency } = useCurrencyFormatter();
	const { i18n } = useI18n();
	const { getReference } = useFootnotes();

	return (
		<Text className="price" tag="p" variant={{ order: '1', style: 'bold', type: 'copy' }}>
			{formatCurrency(priceFragment)}
			{showDisclaimer ? (
				<FootnoteReferenceNgc
					reference={getReference(PRICE_DISCLAIMER_REMARK)}
					ariaLabel={i18n('ngc.a11y.footnotes.price.disclaimer')}
				/>
			) : (
				<></>
			)}
		</Text>
	);
}
